module.exports = __webpack_public_path__ + "img/1f43c.31b4b54.svg";